export enum BookviewPanelStatus {
    None = 0,
    ReferencePanel = 1,
    UserSettingsPanel = 2,
    ShareSpacePanel = 3,
    BookviewChatPanel = 4,
    BookviewSearchPanel = 5,
}
